// 2FA setup/verify/disable mutations.

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";
import type {
  TwoFactorSetupData,
  TwoFactorStatus,
  TwoFactorVerifyResponse,
} from "@/types/profile";

export function useTwoFactorStatus() {
  return useQuery({
    queryKey: ["auth", "2fa", "status"],
    queryFn: () => api<TwoFactorStatus>("/auth/2fa/status"),
  });
}

export function useSetup2FA() {
  return useMutation({
    mutationFn: () =>
      api<TwoFactorSetupData>("/auth/2fa/setup", {
        method: "POST",
        body: {},
      }),
  });
}

export function useVerify2FA() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (code: string) =>
      api<TwoFactorVerifyResponse>("/auth/2fa/verify", {
        method: "POST",
        body: { code },
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["auth", "2fa", "status"] });
    },
  });
}

export interface Disable2FAInput {
  password: string;
  code: string;
}

export function useDisable2FA() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: Disable2FAInput) =>
      api("/auth/2fa/disable", { method: "POST", body: input }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["auth", "2fa", "status"] });
    },
  });
}
